import axiosLib from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUserId, loginSelector } from 'store/slices/loginSlice';

let accessToken;
let refreshToken;
let isRefreshing = false;
let returnPage = '/login'


function setTokens({ access, refresh }) {
  accessToken = access;
  refreshToken = refresh;
  localStorage.setItem('access_token', access);
  localStorage.setItem('refresh_token', refresh);
}

function waitForRefresh(timeout = 5000, interval = 100) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    (function check() {
      if (!isRefreshing) return resolve();
      if (Date.now() - start > timeout) {
        return reject(new Error('Timeout waiting for token refresh'));
      }
      setTimeout(check, interval);
    })();
  });
}

async function fetchWithAuth(input, init = {}) {
  try {
    accessToken = localStorage.getItem('access_token');
    refreshToken = localStorage.getItem('refresh_token');
    init.headers = init.headers || {};
    init.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  catch {}
  let response = await fetch(input, init);
  if (response.status !== 401) {console.log("responce returned"); return response};

  if (!refreshToken) throw new Error('No refresh token available');

  if (isRefreshing) {
    await waitForRefresh();
  } else {
    isRefreshing = true;
    try {
      // refreshToken = localStorage.getItem('refresh_token');
      const userId = getUserId();

      let res;
      if (refreshToken){
        res = await fetch(`${process.env.REACT_APP_DEV_HOST_CORE}/auth/refresh`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refreshToken: refreshToken, userId }),
        });
      }

      if (!res.ok) {
        window.location.href = returnPage;
        throw new Error('Failed to refresh token');
      }

      const data = await res.json();
      setTokens({ access: data.accessToken, refresh: data.refreshToken });
    } 
    catch {
      window.location.href = returnPage;
    }
    finally {
      isRefreshing = false;
    }
  }

  init.headers['Authorization'] = `Bearer ${accessToken}`;
  return fetch(input, init);
}

class AxiosWithRefresh {
  constructor(baseURL = '') {
    this.instance = axiosLib.create({ baseURL });

    this.instance.interceptors.request.use(config => {
      accessToken = localStorage.getItem('access_token');
      config.headers.Authorization = `Bearer ${accessToken}`;
      return config;
    });

    this.instance.interceptors.response.use(
      res => res,
      async error => {
        const originalRequest = error.config;
        if (error.response?.status !== 401 || originalRequest._retry) {
          return Promise.reject(error);
        }

        originalRequest._retry = true;

        if (!refreshToken) return Promise.reject(error);

        if (isRefreshing) {
          await waitForRefresh();
        } else {
          isRefreshing = true;
          try {
            refreshToken = localStorage.getItem('refresh_token');
            const userId = getUserId();
            const res = await axiosLib.post(`${process.env.REACT_APP_DEV_HOST_CORE}/auth/refresh`, { refreshToken: refreshToken, userId});
            setTokens({ access: res.data.accessToken, refresh: res.data.refreshToken });
          } 
          catch {
            window.location.href = returnPage;
          }
          finally {
            isRefreshing = false;
          }
        }

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return this.instance(originalRequest);
      }
    );
  }

  get(url, config) {
    return this.instance.get(url, config);
  }

  post(url, data, config) {
    return this.instance.post(url, data, config);
  }

  put(url, data, config) {
    return this.instance.put(url, data, config);
  }

  delete(url, config) {
    return this.instance.delete(url, config);
  }
}


const ffetch = fetchWithAuth;
const axios = new AxiosWithRefresh();

export { ffetch, axios };